import React from 'react';

const Badge = ({ children, variant = 'default', className = '' }) => {
  const variants = {
    default: 'bg-brand-raised text-brand-secondary border border-brand-border',
    new: 'bg-brand-mint/10 text-brand-mint border border-brand-mint/20',
    editor: 'bg-brand-editor/10 text-brand-editor border border-brand-editor/20',
    breaking: 'bg-brand-breaking/10 text-brand-breaking border border-brand-breaking/20',
    trending: 'bg-brand-trending/10 text-brand-trending border border-brand-trending/20',
  };

  // Map old mock data variants to new ones seamlessly
  const mappedVariant = variant === 'cyan' ? 'new' : variant === 'purple' ? 'editor' : variant;

  return (
    <span className={`px-2 py-0.5 rounded-[4px] text-[11px] font-mono uppercase tracking-wide font-medium ${variants[mappedVariant] || variants.default} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;